const STORAGE_PREFIX = "edify-profile-post-gen-v1:"
const WINDOW_MS = 25 * 60 * 1000
const MAX_REQUESTS_IN_WINDOW = 3

type StoredShape = { t: number[] }

function storageKey(userId: string | number): string {
  return `${STORAGE_PREFIX}${String(userId)}`
}

function readTimestamps(userId: string | number): number[] {
  try {
    const raw = localStorage.getItem(storageKey(userId))
    if (!raw) return []
    const parsed = JSON.parse(raw) as StoredShape
    return Array.isArray(parsed?.t) ? parsed.t.filter((n) => typeof n === "number") : []
  } catch {
    return []
  }
}

function writeTimestamps(userId: string | number, timestamps: number[]): void {
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify({ t: timestamps }))
  } catch {
    return
  }
}

export function canRequestProfilePostGeneration(
  userId: string | number | undefined | null
): { ok: true } | { ok: false; retryAfterMs: number } {
  if (userId == null || String(userId).trim() === "") return { ok: true }

  const now = Date.now()
  const inWindow = readTimestamps(userId).filter((t) => now - t < WINDOW_MS).sort((a, b) => a - b)

  if (inWindow.length < MAX_REQUESTS_IN_WINDOW) return { ok: true }

  const oldest = inWindow[0]
  return { ok: false, retryAfterMs: Math.max(0, oldest + WINDOW_MS - now) }
}

export function recordSuccessfulProfilePostGeneration(userId: string | number | undefined | null): void {
  if (userId == null || String(userId).trim() === "") return

  const now = Date.now()
  const next = [...readTimestamps(userId).filter((t) => now - t < WINDOW_MS), now]
  writeTimestamps(userId, next)
}

export function formatProfilePostRetryMinutes(retryAfterMs: number): string {
  const m = Math.max(1, Math.ceil(retryAfterMs / 60000))
  return m === 1 ? "1 minuto" : `${m} minutos`
}
